import { apiDealTypes, PIPELINE_MAP } from 'model/deals.model';
import { useEffect, useState } from 'react';
import { DealsService } from 'service/deals.service';

export const usePipelineOptions = () => {
  const [pipelineOptions, setPipelineOptions] = useState<string[]>([]);
  const [selectedPipelines, setSelectedPipelines] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchPipelines = async () => {
      try {
        setLoading(true);
        const data: Record<string, string> = await DealsService.getDealTypes();
        const formattedKeys = Object.keys(data).map(
          (key) => PIPELINE_MAP[key as apiDealTypes] || key,
        );
        setPipelineOptions(formattedKeys);
      } catch (error) {
        console.error('Failed to fetch pipeline types', error);
        setPipelineOptions([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPipelines();
  }, []);

  return {
    pipelineOptions,
    selectedPipelines,
    setSelectedPipelines,
    loading,
  };
};
